import { render, staticRenderFns } from "./RecordingTableStaff.vue?vue&type=template&id=3de4ffe0&scoped=true&"
import script from "./RecordingTableStaff.vue?vue&type=script&lang=js&"
export * from "./RecordingTableStaff.vue?vue&type=script&lang=js&"
import style0 from "./RecordingTableStaff.vue?vue&type=style&index=0&id=3de4ffe0&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de4ffe0",
  null
  
)

export default component.exports